import React from "react";
import { Link } from "react-router-dom";
import "../css/privacy.scss";

function Cookies() {
  return (
    <main className="content-for-layout" role="main">
      <div className="policy__container">
        <div className="policy__title">
          <h1>Cookie policy</h1>
        </div>
        <div className="policy__body">
          <div className="rte">
            <p>COOKIE AND BROWSER STORAGE NOTICE</p>
            <p>Last updated: September 7, 2026</p>
            <p>
              This policy explains how dilverbloom uses cookies and similar
              browser technologies when you visit our website.
            </p>
            <p>
              <strong>Essential storage</strong><br />
              Our site uses browser local storage to remember the contents of
              your shopping cart. This information supports the shopping
              experience and does not contain your payment card details.
            </p>
            <p>
              <strong>Service-provider technologies</strong><br />
              Content delivery, payment, security, or other service providers
              may use their own cookies or similar technologies when their
              services are loaded or when you continue to their pages. Their
              handling of information is governed by their own notices.
            </p>
            <p>
              <strong>Your choices</strong><br />
              You can remove or block cookies through your browser settings and
              clear local storage through your browser&apos;s site-data controls.
              Blocking essential storage may prevent the cart from being
              retained between visits.
            </p>
            <p>
              <strong>Policy updates</strong><br />
              We may update this policy when our technology or legal obligations
              change. The date above shows the latest revision.
            </p>
            <p>
              Questions may be sent to build@dilverbloom.online. For additional
              information about personal data, see our{" "}
              <Link to="/privacy">Privacy Policy</Link>.
            </p>
          </div>
        </div>
      </div>
    </main>
  );
}

export default Cookies;
